<template>

    <div class="relative cursor-pointer bg-gray-100 text-gray-600 hover:text-gray-700 px-3 py-2 rounded-lg flex items-center w-full gap-x-2 mt-1"
        v-clipboard:copy="copyText" v-clipboard:success="confirmCopy" v-clipboard:error="errorCopy">

        <LinkIcon
            :class="[copied ? 'opacity-0' : 'opacity-100', 'h-4 w-4 flex-shrink-0 z-10  transition-opacity duration-300']"
            v-tippy="{ content: 'Click to copy' }" />

        <span
            :class="[copied ? 'opacity-0' : 'opacity-100', 'flex-grow flex-shrink truncate text-sm transition-opacity duration-300']"
            v-html="copyLabel != '' ? copyLabel : copyText"></span>

        <div
            :class="[copied ? 'opacity-100' : 'opacity-0', 'absolute top-1/2 -translate-y-1/2 left-2 pointer-events-none px-1 flex items-center text-sm transition-opacity duration-300 gap-x-2']">
            <CheckIcon class="h-4 w-4 flex-shrink-0" />
            <span class="flex-grow flex-shrink truncate text-sm">{{ copySuccess }}</span>
        </div>

        <div
            :class="[error_copy ? 'opacity-100' : 'opacity-0', 'absolute top-1 bottom-1 left-2 bg-red-600 pointer-events-none text-white rounded-md  px-4 flex items-center justify-center text-sm font-medium transition-opacity min-w-96']">
            Could not copy - select text manually instead</div>

    </div>

</template>

<script>


import { LinkIcon, CheckIcon } from "@heroicons/vue/24/outline"

export default {
    props: {
        copyText: {
            type: String,
            default: '',
        },
        copyLabel: {
            type: String,
            default: '',
        },
        copySuccess: {
            type: String,
            default: 'copied!',
        },
        timeout: {
            type: Number,
            default: 2.5,
        }
    },
    components: {
        LinkIcon, CheckIcon
    },
    data() {
        return {
            copied: false,
            error_copy: false
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        confirmCopy: function() {
            this.copied = true
            setTimeout(function(){
                this.copied = false
            }.bind(this), this.timeout*1000)
        },
        errorCopy: function() {
            this.error_copy = true
            setTimeout(function(){
                this.error_copy = false
            }.bind(this), this.timeout*1000)
        }
    }

}

</script>
